export interface SupportContact {
  title: string;
  description: string;
  email: string;
}

export const SUPPORT_PAGE_TITLE = "Kontakta oss";
export const SUPPORT_PAGE_SUBTITLE =
  "Här kan du hitta rätt kontaktperson för dina frågor";

export const SUPPORT_CONTACTS: { sectionTitle: string; contacts: SupportContact[] }[] = [
  {
    sectionTitle: "Affärsmässiga frågor & försäljning",
    contacts: [
      {
        title: "Sizar",
        description: "Affärsmässiga frågor och försäljning",
        email: "sizar.noori@satelles.se",
      },
    ],
  },
  {
    sectionTitle: "Tekniska frågor",
    contacts: [
      {
        title: "Support",
        description: "Teknisk support och IT-frågor",
        email: "support@satelles.se",
      },
    ],
  },
];
